<ng-container *transloco="let t">
  @if (!isDraft() && mediaPreviewUri() && !imageError()) {
    <img
      class="size-14 shrink-0 rounded-sm object-cover"
      data-testid="thumbnail"
      [alt]="entity() | sadmEntityName: sadmType()"
      [src]="mediaPreviewUri()"
      (error)="onImageLoadingError()" />
  } @else {
    <pxc-image-broken class="size-14! shrink-0" />
  }

  <div class="flex min-w-0 flex-1 flex-col">
    @if (isDraft()) {
      <p class="truncate text-base font-medium leading-tight text-text-primary">
        {{ t('Nouvelle lésion') }}
      </p>
    } @else {
      <p class="truncate text-sm text-text-tertiary font-normal">
        {{ entity() | sadmEntityType: sadmType() }}
      </p>
      <p class="truncate text-base font-medium leading-tight text-text-primary">
        {{ entity() | sadmEntityName }}
      </p>
    }
  </div>

  <pxc-action-buttons
    iconOnly
    size="xs"
    [actionButtons]="actionButtons"
    [actions]="actions"
    [entity]="entity()"
    [hintDirection]="'left'" />
</ng-container>
